import * as React from 'react';
import {
  Building2,
  Monitor,
  Wifi,
  Users,
  Bell,
  Activity,
} from 'lucide-react';
import { IKpiCard } from '../analytics.types';

const ICON_PROPS = { size: 24, strokeWidth: 1.5 } as const;

const ICON_MAP: Record<string, React.ReactNode> = {
  organizations: <Building2 {...ICON_PROPS} />,
  devices: <Monitor {...ICON_PROPS} />,
  online: <Wifi {...ICON_PROPS} />,
  users: <Users {...ICON_PROPS} />,
  alerts: <Bell {...ICON_PROPS} />,
};

interface IKpiCardComponentProps {
  kpi: IKpiCard;
  highlight?: boolean;
  subtitleOverride?: string;
}

const KpiCardComponent = ({ kpi, highlight, subtitleOverride }: IKpiCardComponentProps) => {
  const icon = ICON_MAP[kpi.icon] || <Activity {...ICON_PROPS} />;

  return (
    <div className={`kpi-card ${highlight ? 'kpi-card-highlight' : ''}`}>
      <div className="kpi-card-header">
        <div className={`kpi-icon kpi-icon-${kpi.icon}`}>{icon}</div>
      </div>
      <div className="kpi-value">{kpi.value.toLocaleString()}</div>
      <div className="kpi-title">{kpi.title}</div>
      <div className="kpi-subtitle">{subtitleOverride || kpi.subtitle}</div>
    </div>
  );
};

export default KpiCardComponent;
